import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex" }
const _hoisted_2 = { class: "flex flex-wrap justify-between p-2" }
const _hoisted_3 = { class: "text-blue-900 font-bold text-left border-l-4 border-blue-900" }
const _hoisted_4 = { class: "sm:block md:hidden" }

import SidebarComponent from "@/components/learn-english/SidebarComponent.vue";
import NavigateBackComponent from "@/components/navigation/NavigateBackComponent.vue";

import { User } from "@/models/user";
import store from "@/store";

import { ref, onMounted } from "vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'LearnEnglishPagePatternLayout',
  props: {
  backTo: {
    type: String,
    required: false,
    default: null,
  },
  title: {
    type: String,
    required: true,
  },
  footer: {
    type: Object,
    required: false,
  },
},
  setup(__props) {

const user = ref<User | null>(null);

onMounted(async () => {
  user.value = (store.getters["auth/user"] as User) || null;
});


return (_ctx: any,_cache: any) => {
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_layout, { class: "min-h-screen flex" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_sider, { class: "hidden md:block bg-white w-64 shadow-md" }, {
          default: _withCtx(() => [
            _createVNode(SidebarComponent)
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout, { class: "flex-1" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, "   " + _toDisplayString(__props.title), 1),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(NavigateBackComponent, { "back-to": __props.backTo }, null, 8, ["back-to"])
              ])
            ]),
            _createVNode(_component_a_layout_content, { class: "my-2 bg-gray-300 bg-opacity-10 p-2" }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "content")
              ]),
              _: 3
            }),
            _createVNode(_component_a_layout_footer, { class: "bg-gray-300 bg-opacity-10" }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "footer")
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    })
  ]))
}
}

})